import { render } from "./PortfolioDetail.vue?vue&type=template&id=4c25de24&scoped=true"
import script from "./PortfolioDetail.vue?vue&type=script&lang=js"
export * from "./PortfolioDetail.vue?vue&type=script&lang=js"

import "./PortfolioDetail.vue?vue&type=style&index=0&id=4c25de24&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4c25de24"

export default script